// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    $("body").click(function (e) {
      if (e.target.classList.contains("card-quickbuy__label")) {
        const target = e.target;
        const parentFieldset = target.closest("fieldset");
        parentFieldset
          .querySelector("label.checked")
          ?.classList.remove("checked");
        target.classList.add("checked");

        const compreJunto = target.closest(".product-item--compre-junto");
        const form = target.closest(".card-quickbuy--form");

        const isKit = compreJunto
          ? JSON.parse(compreJunto.dataset.variantIds).length == 2
          : form?.classList.contains("card-quickbuy--kit");

        const isSoldout = compreJunto
          ? compreJunto.querySelectorAll(
              ".card-quickbuy__label.soldout.checked"
            ).length > 0
          : target.classList.contains("soldout");

        // Lógica do quickbuy para o módulo de compre junto
        if (compreJunto) {
          // Desabilita o card de produto caso algum item selecionado esteja soldout
          const addButton = compreJunto.querySelector(".card-product__add-button");

          if (
            (isSoldout && compreJunto.classList.contains("checked")) ||
            (!isSoldout && !compreJunto.classList.contains("checked"))
          ) {
            $(addButton).trigger("click");
          }

          const fieldset = target.closest("fieldset");
          const variantIds = JSON.parse(compreJunto.dataset.variantIds);
          
          const variantIdsNew = variantIds.map(v => {
            if(fieldset.dataset.kit == v.kit || (variantIds.length == 1)) {
              return {
                ...v,
                id: parseInt(target.dataset.variantId)
              }
            }
            return v;
          })    

          compreJunto.setAttribute('data-variant-ids', JSON.stringify(variantIdsNew))
        } else {
          const submitButton = form.querySelector(".card-quickbuy__submit");
          if (submitButton) {
            if (!isKit) {
              if (isSoldout) {
                submitButton.textContent = window.card_soldout;
                submitButton.disabled = true;
              } else {
                submitButton.textContent = window.card_add_to_cart;
                submitButton.disabled = false;
              }

              $(submitButton).show();
            } else {
              const fieldsets = form.querySelectorAll("fieldset");
              const selectedRadios = form.querySelectorAll("label.checked");

              let isSoldout = false;
              if (selectedRadios.length == fieldsets.length) {
                selectedRadios.forEach((radio) => {
                  if (radio.classList.contains("soldout")) {
                    isSoldout = true;
                  }
                });

                if (isSoldout) {
                  submitButton.textContent = window.card_soldout;
                  submitButton.disabled = true;
                } else {
                  submitButton.textContent = window.card_add_to_cart;
                  submitButton.disabled = false;
                }

                $(submitButton).show();
              }
            }
          }
        }
      }
    });

    $("body").click(function (e) {
      if (e.target.classList.contains("card-quickbuy__submit")) {
        const submitButton = e.target;
        e.preventDefault();
        submitButton.disabled = true;
        const form = submitButton.closest(".card-quickbuy--form");
        const isKit = form.classList.contains("card-quickbuy--kit");
        let formData = { items: [] };

        if (!isKit) {
          const input = form.querySelector("label.checked");
          const isSoldout = input.classList.contains("soldout");

          if (!isSoldout) {
            formData.items.push({ id: input.dataset.variantId, quantity: 1 });
          }
        } else {
          const fieldsets = form.querySelectorAll("fieldset");
          const inputs = form.querySelectorAll("label.checked:not(.soldout)");

          if (inputs.length == fieldsets.length) {
            inputs.forEach((input) => {
              formData.items.push({ id: input.dataset.variantId, quantity: 1 });
            });
          }
        }

        if (formData.items.length > 0) {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              Shopify.getCart((cart) => {
                window.updateCart(cart);
              });
              submitButton.disabled = false;
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    });
  });
})(jQuery);
